export default __webpack_public_path__ + "static/media/5453@2x.ca8e06b5.webp";